/**
 * RevenueFlows v5.0 — Product Page JavaScript
 * Handles: Gallery, Variants, Cart, Sticky Header, FAQ, Scroll Reveal, Sticky Footer
 */
(function () {
  'use strict';

  /* ──────────────────────────────────────────────
     State
  ────────────────────────────────────────────── */
  var currentImageIndex = 0;
  var images = [];
  var variants = [];
  var selectedOptions = {};

  /* ──────────────────────────────────────────────
     Boot
  ────────────────────────────────────────────── */
  function init() {
    initGallery();
    initVariantSystem();
    initStickyHeader();
    initFaqAccordion();
    initScrollReveal();
    initAjaxCart();
    initStickyFooter();
  }

  /* ══════════════════════════════════════════════
     1. GALLERY / THUMBNAILS
  ══════════════════════════════════════════════ */
  function initGallery() {
    var dataEl = document.getElementById('rf-product-images');
    if (!dataEl) return;

    try {
      images = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.warn('[RF] Could not parse product images JSON:', e);
      return;
    }

    if (!images.length) return;

    // Render thumbnails if a container exists
    renderThumbnails();

    // Set first image as active
    updateMainImage(0);

    // Touch swipe on main image
    initTouchSwipe();
  }

  /**
   * Render thumbnail buttons from image data.
   */
  function renderThumbnails() {
    var container = document.querySelector('.rf-thumbnails');
    if (!container) return;

    // If thumbnails are already in HTML, just bind clicks
    var existing = container.querySelectorAll('.thumbnail');
    if (existing.length) {
      bindThumbnailClicks(existing);
      return;
    }

    // Otherwise generate them
    images.forEach(function (img, i) {
      var thumb = document.createElement('button');
      thumb.className = 'thumbnail' + (i === 0 ? ' active' : '');
      thumb.setAttribute('data-image-index', i);
      thumb.setAttribute('aria-label', 'View image ' + (i + 1));

      var pic = document.createElement('img');
      pic.src = img.thumb || img.src;
      pic.alt = img.alt || 'Product image ' + (i + 1);
      pic.loading = 'lazy';
      thumb.appendChild(pic);
      container.appendChild(thumb);
    });

    bindThumbnailClicks(container.querySelectorAll('.thumbnail'));
  }

  /**
   * Attach click handlers to thumbnail elements.
   */
  function bindThumbnailClicks(thumbs) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = parseInt(this.getAttribute('data-image-index'), 10);
        if (!isNaN(idx)) goToImage(idx);
      });
    });
  }

  /**
   * Update the main image and toggle active thumbnail.
   */
  function updateMainImage(index) {
    if (index < 0 || index >= images.length) return;
    currentImageIndex = index;

    var mainImg = document.getElementById('mainImage');
    if (mainImg && images[index]) {
      mainImg.src = images[index].src;
      mainImg.alt = images[index].alt || 'Product image';
    }

    // Toggle active class on thumbnails
    var thumbs = document.querySelectorAll('.thumbnail');
    thumbs.forEach(function (t, i) {
      t.classList.toggle('active', i === index);
    });
  }

  /**
   * Navigate gallery by direction: 1 (next) or -1 (prev).
   */
  function navigateGallery(direction) {
    if (!images.length) return;
    var next = (currentImageIndex + direction + images.length) % images.length;
    updateMainImage(next);
  }

  /**
   * Jump to a specific image index.
   */
  function goToImage(index) {
    if (index >= 0 && index < images.length) {
      updateMainImage(index);
    }
  }

  /**
   * Touch swipe support on the main image container.
   */
  function initTouchSwipe() {
    var mainImg = document.getElementById('mainImage');
    if (!mainImg) return;

    var startX = 0;
    var SWIPE_THRESHOLD = 50;

    mainImg.addEventListener('touchstart', function (e) {
      startX = e.changedTouches[0].clientX;
    }, { passive: true });

    mainImg.addEventListener('touchend', function (e) {
      var diff = e.changedTouches[0].clientX - startX;
      if (Math.abs(diff) < SWIPE_THRESHOLD) return;
      // Swipe left = next, swipe right = prev
      navigateGallery(diff < 0 ? 1 : -1);
    }, { passive: true });
  }

  /* ══════════════════════════════════════════════
     2. VARIANT PICKER
  ══════════════════════════════════════════════ */
  function initVariantSystem() {
    var dataEl = document.getElementById('rf-product-variants');
    if (!dataEl) return;

    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.warn('[RF] Could not parse product variants JSON:', e);
      return;
    }

    // Pre-select the first available variant
    if (variants.length) {
      var first = variants[0];
      if (first.option1) selectedOptions['option1'] = first.option1;
      if (first.option2) selectedOptions['option2'] = first.option2;
      if (first.option3) selectedOptions['option3'] = first.option3;
      applyVariant(first);
    }

    // Bind variant button clicks
    var btns = document.querySelectorAll('.rf-size-btn');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var optionName = this.getAttribute('data-option-name');
        var optionValue = this.getAttribute('data-option-value');
        if (optionName && optionValue) {
          handleOptionChange(this, optionValue, optionName);
        }
      });
    });
  }

  /**
   * Handle a variant option change.
   * Updates selected options, finds the matching variant, and applies it.
   */
  function handleOptionChange(el, value, optionName) {
    // Update selection state
    selectedOptions[optionName] = value;

    // Toggle active state on sibling buttons
    var group = el.closest('.rf-option-group') || el.parentElement;
    if (group) {
      group.querySelectorAll('.rf-size-btn').forEach(function (btn) {
        btn.classList.toggle('active', btn.getAttribute('data-option-value') === value);
      });
    }

    // Find matching variant
    var match = findMatchingVariant();
    if (match) {
      applyVariant(match);
    }
  }

  /**
   * Find a variant that matches all currently selected options.
   */
  function findMatchingVariant() {
    return variants.find(function (v) {
      var match = true;
      if (selectedOptions.option1 && v.option1 !== selectedOptions.option1) match = false;
      if (selectedOptions.option2 && v.option2 !== selectedOptions.option2) match = false;
      if (selectedOptions.option3 && v.option3 !== selectedOptions.option3) match = false;
      return match;
    }) || null;
  }

  /**
   * Apply a variant: update hidden input, price, URL, and gallery image.
   */
  function applyVariant(variant) {
    // Update hidden variant ID
    var hiddenInput = document.getElementById('rf-variant-id');
    if (hiddenInput) {
      hiddenInput.value = variant.id;
    }

    // Update price display
    updatePriceDisplay(variant);

    // Update URL without reload
    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState(null, '', url.toString());
    }

    // If variant has a featured image, update gallery
    if (variant.featured_image && variant.featured_image.src) {
      var matchIdx = images.findIndex(function (img) {
        return img.src === variant.featured_image.src;
      });
      if (matchIdx !== -1) {
        updateMainImage(matchIdx);
      }
    }

    // Update add-to-cart button availability
    var addBtn = document.getElementById('rfAddToCart');
    if (addBtn) {
      if (variant.available === false) {
        addBtn.disabled = true;
        addBtn.textContent = 'Sold Out';
      } else {
        addBtn.disabled = false;
        addBtn.textContent = 'Buy Now';
      }
    }
  }

  /**
   * Update the price display element with variant pricing.
   */
  function updatePriceDisplay(variant) {
    var container = document.getElementById('rfPriceDisplay');
    if (!container) return;

    var price = formatMoney(variant.price);
    var comparePrice = variant.compare_at_price ? formatMoney(variant.compare_at_price) : '';

    if (comparePrice && variant.compare_at_price > variant.price) {
      container.innerHTML =
        '<span class="rf-price-current">' + price + '</span>' +
        '<span class="rf-price-compare">' + comparePrice + '</span>';
    } else {
      container.innerHTML = '<span class="rf-price-current">' + price + '</span>';
    }
  }

  /**
   * Format cents into dollars (Shopify prices are in cents).
   */
  function formatMoney(cents) {
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }

  /* ══════════════════════════════════════════════
     3. QUANTITY CONTROLS
  ══════════════════════════════════════════════ */

  /**
   * Increment or decrement the quantity input.
   * @param {number} delta — typically +1 or -1
   */
  function updateQty(delta) {
    var input = document.getElementById('rfQty');
    if (!input) return;

    var current = parseInt(input.value, 10) || 1;
    var next = Math.min(10, Math.max(1, current + delta));
    input.value = next;

    // Sync sticky footer qty if present
    var footerQty = document.querySelector('#stickyFooter .rf-sticky-qty-value');
    if (footerQty) {
      footerQty.textContent = next;
    }
  }

  /* ══════════════════════════════════════════════
     4. AJAX CART
  ══════════════════════════════════════════════ */
  function initAjaxCart() {
    var addBtn = document.getElementById('rfAddToCart');
    if (!addBtn) return;

    var form = addBtn.closest('form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCartAndCheckout();
    });
  }

  /**
   * POST item to cart via AJAX, then redirect to checkout.
   */
  function addToCartAndCheckout() {
    var variantInput = document.getElementById('rf-variant-id');
    var qtyInput = document.getElementById('rfQty');

    var variantId = variantInput ? variantInput.value : null;
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    if (!variantId) {
      console.warn('[RF] No variant selected');
      return;
    }

    var addBtn = document.getElementById('rfAddToCart');
    var originalText = addBtn ? addBtn.textContent : '';
    if (addBtn) {
      addBtn.disabled = true;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: qty
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart error ' + res.status);
        return res.json();
      })
      .then(function () {
        if (addBtn) { addBtn.disabled = false; }
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        console.error('[RF] Add to cart failed:', err);
        if (addBtn) {
          addBtn.disabled = false;
        }
        // Fallback: direct cart URL
        setTimeout(function () {
          window.location.href = '/cart/' + variantId + ':' + qty;
        }, 2000);
      });
  }

  /* ══════════════════════════════════════════════
     5. STICKY HEADER
  ══════════════════════════════════════════════ */
  function initStickyHeader() {
    var buySection = document.getElementById('buy-now');
    var nav = document.getElementById('rfNav');
    if (!buySection || !nav) return;

    // Remove any leftover spacers from previous versions
    document.querySelectorAll('.rf-nav-spacer').forEach(function(s) { s.remove(); });

    // Force theme header to be non-sticky (sandwiched mode)
    // This prevents the theme header from peeking through on scroll
    var themeHeader = document.querySelector('#shopify-section-header');
    if (themeHeader) {
      themeHeader.style.position = 'relative';
      // Also check for sticky wrappers inside the header
      var headerInner = themeHeader.querySelector('.header-wrapper, .header, .sticky-header, [class*="header"]');
      if (headerInner) headerInner.style.position = 'relative';
    }

    // Nav is already position:sticky via CSS — no spacer needed
    // Just toggle is-sticky class for visual state changes
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          nav.classList.add('is-sticky');
        } else {
          nav.classList.remove('is-sticky');
        }
      });
    }, {
      threshold: 0,
      rootMargin: '0px'
    });

    observer.observe(buySection);
  }

  /* ══════════════════════════════════════════════
     6. FAQ ACCORDION
  ══════════════════════════════════════════════ */
  function initFaqAccordion() {
    var triggers = document.querySelectorAll('.faq-trigger');
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var parentItem = this.closest('.faq-item');
        if (!parentItem) return;

        var isActive = parentItem.classList.contains('active');

        // Close all other FAQ items
        document.querySelectorAll('.faq-item.active').forEach(function (item) {
          item.classList.remove('active');
        });

        // Toggle the clicked item (open if it was closed)
        if (!isActive) {
          parentItem.classList.add('active');
        }
      });
    });

    // First item is already open via HTML (.active class), so no JS needed for default
  }

  /* ══════════════════════════════════════════════
     7. SCROLL REVEAL
  ══════════════════════════════════════════════ */
  function initScrollReveal() {
    var revealEls = document.querySelectorAll('[data-reveal]');
    if (!revealEls.length) return;

    if (!('IntersectionObserver' in window)) {
      // Fallback: reveal everything immediately
      revealEls.forEach(function (el) {
        el.classList.add('revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          obs.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    revealEls.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ══════════════════════════════════════════════
     8. STICKY FOOTER
  ══════════════════════════════════════════════ */
  function initStickyFooter() {
    var heroInfo = document.querySelector('.rf-hero-info');
    var stickyFooter = document.getElementById('stickyFooter');
    if (!heroInfo || !stickyFooter) return;

    // Show/hide footer based on product info visibility
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          stickyFooter.classList.add('visible');
        } else {
          stickyFooter.classList.remove('visible');
        }
      });
    }, {
      threshold: 0
    });

    observer.observe(heroInfo);

    // Sticky footer quantity buttons
    var footerQtyBtns = stickyFooter.querySelectorAll('[data-action]');
    footerQtyBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var action = this.getAttribute('data-action');
        if (action === 'increase') {
          updateQty(1);
        } else if (action === 'decrease') {
          updateQty(-1);
        }
      });
    });

    // Sticky footer buy button
    var stickyBuyBtn = document.getElementById('stickyBuyBtn');
    if (stickyBuyBtn) {
      stickyBuyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        addToCartAndCheckout();
      });
    }
  }

  /* ══════════════════════════════════════════════
     GLOBAL FUNCTIONS
     Exposed on window for inline onclick handlers in HTML
  ══════════════════════════════════════════════ */
  window.navigateGallery = function (direction) {
    navigateGallery(direction);
  };

  window.goToImage = function (index) {
    goToImage(index);
  };

  window.handleOptionChange = function (el, value, optionName) {
    handleOptionChange(el, value, optionName);
  };

  window.updateQty = function (delta) {
    updateQty(delta);
  };

  /* ──────────────────────────────────────────────
     Initialize when DOM is ready
  ────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
